import { isNil, omitBy } from 'lodash'

import { getIdsFromArray } from '@/utils/utils'

export function adaptCollectionToApi(collection = {}) {
  let payload = {
    name: collection.name,
    slug: collection.slug,
    url: collection.url,
    description: collection.description,
    instructors: collection.instructors,
    difficulty: collection.difficulty,
    learning_areas: collection.learning_areas,
    main_learning_area: collection.main_learning_area,
    categories: collection.categories,
    vendor: collection.vendor,
    tags: collection.tags,
    content: adaptContentToApi(collection.content),
    status: collection.status,
    is_featured: collection.is_featured,
    related_collections: collection.related_collections,
    featured_labs: collection.featured_labs,
  }
  payload = omitBy(payload, isNil)
  // difficulty, vendor and main_learniing_area can be null
  payload.main_learning_area = collection.main_learning_area
  payload.difficulty = collection.difficulty
  return payload
}

export function adaptCollectionToStore(collection = {}) {
  /// MOCK ///
  collection.data.access = collection.data.access
    ? collection.data.access
    : {
        related_passes: [],
      }
  ///////////
  return {
    ...collection.data,
    vendor: collection.data.vendor ? collection.data.vendor.id : null,
    instructors: getIdsFromArray(collection.data.instructors),
    learning_areas: getIdsFromArray(collection.data.learning_areas),
    categories: getIdsFromArray(collection.data.categories),
    access: {
      ...collection.data.access,
      related_passes: collection.data.access.related_passes,
    },
  }
}

export function adaptCollectionsToStore(collections = []) {
  const collectionList = {
    entries: collections.data.results.reduce((acc, collection) => {
      acc[collection.id] = adaptCollectionToStore({ data: collection })
      return acc
    }, {}),
    next: collections.data.next,
    previous: collections.data.previous,
    count: collections.data.count,
    results: collections.data.results.reduce((acc, collection) => {
      acc.push(
        adaptCollectionToStore({
          data: collection,
        })
      )
      return acc
    }, []),
  }
  return collectionList
}

/**
 * delete all duration_in_seconds from content
 */
function adaptContentToApi(content) {
  if (!content) return content
  for (let i = 0; i < content.length; i++) {
    let element = content[i]
    if ('duration_in_seconds' in element) {
      delete element.duration_in_seconds
    }
    if (element.content && element.content.length) {
      for (let j = 0; j < element.content.length; j++) {
        let elementB = element.content[j]
        if ('duration_in_seconds' in elementB) {
          delete elementB.duration_in_seconds
        }
        if (elementB.content && elementB.content.length) {
          for (let j = 0; j < elementB.content.length; j++) {
            let elementC = elementB.content[j]
            if ('related' in elementC) {
              delete elementC.related
            }
          }
        }
      }
    }
  }
  return content
}
